import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.7,
    delay
  }} data-id="element-46">
      {children}
    </motion.div>;
}
export function DeliverablesSection() {
  return <section className="w-full py-20 px-4" style={{
    background: 'linear-gradient(180deg, #0a1628 0%, #0d1a2e 50%, #0a1628 100%)'
  }} data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <FadeInUp data-id="element-49">
          <div className="text-center mb-14" data-id="element-50">
            <div className="section-divider mb-6" data-id="element-51">
              <span className="ornament" data-id="element-52">◈</span>
            </div>
            <h2 className="font-heading font-700 text-4xl md:text-5xl mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-53">
              Todo Lo Que Recibes
              <span className="block italic" style={{
              color: 'var(--color-gold)'
            }} data-id="element-54">
                Con Tu Acceso Hoy
              </span>
            </h2>
            <p className="font-body text-lg" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-55">
              Un sistema completo de restauración, no solo un libro.
            </p>
          </div>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-56">
          <FadeInUp delay={0.1} data-id="element-57">
            <div className="rounded-xl p-6 flex gap-5 items-start h-full" style={{
            background: 'rgba(15, 31, 61, 0.7)',
            border: '1px solid rgba(201, 168, 76, 0.25)'
          }} data-id="element-58">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-xl" style={{
              background: 'rgba(201, 168, 76, 0.12)',
              border: '1px solid rgba(201, 168, 76, 0.3)'
            }} data-id="element-59">
                📚
              </div>
              <div data-id="element-60">
                <h3 className="font-heading font-600 text-xl mb-2" style={{
                color: 'var(--color-gold)'
              }} data-id="element-61">
                  El Manual Maestro
                </h3>
                <p className="font-body text-sm leading-relaxed" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-62">
                  100 páginas de sabiduría biográfica y espiritual aplicada paso
                  a paso. La guía central de todo el sistema.
                </p>
              </div>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.15} data-id="element-63">
            <div className="rounded-xl p-6 flex gap-5 items-start h-full" style={{
            background: 'rgba(15, 31, 61, 0.7)',
            border: '1px solid rgba(201, 168, 76, 0.25)'
          }} data-id="element-64">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-xl" style={{
              background: 'rgba(74, 158, 255, 0.1)',
              border: '1px solid rgba(74, 158, 255, 0.3)'
            }} data-id="element-65">
                🗓️
              </div>
              <div data-id="element-66">
                <h3 className="font-heading font-600 text-xl mb-2" style={{
                color: 'var(--color-blue-glow)'
              }} data-id="element-67">
                  Protocolo de 21 Días
                </h3>
                <p className="font-body text-sm leading-relaxed" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-68">
                  El mapa exacto de qué comer y cuándo hacerlo para resetear tu
                  metabolismo. Día a día, sin adivinar.
                </p>
              </div>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.2} data-id="element-69">
            <div className="rounded-xl p-6 flex gap-5 items-start h-full" style={{
            background: 'rgba(15, 31, 61, 0.7)',
            border: '1px solid rgba(201, 168, 76, 0.25)'
          }} data-id="element-70">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-xl" style={{
              background: 'rgba(74, 124, 89, 0.12)',
              border: '1px solid rgba(74, 124, 89, 0.3)'
            }} data-id="element-71">
                🫒
              </div>
              <div data-id="element-72">
                <h3 className="font-heading font-600 text-xl mb-2" style={{
                color: 'var(--color-olive)'
              }} data-id="element-73">
                  Guía de los 7 Superalimentos
                </h3>
                <p className="font-body text-sm leading-relaxed" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-74">
                  Cómo usar el aceite de oliva, la granada y otros pilares
                  bíblicos para detener la oxidación celular.
                </p>
              </div>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.25} data-id="element-75">
            <div className="rounded-xl p-6 flex gap-5 items-start h-full" style={{
            background: 'rgba(15, 31, 61, 0.7)',
            border: '1px solid rgba(201, 168, 76, 0.25)'
          }} data-id="element-76">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-xl" style={{
              background: 'rgba(201, 168, 76, 0.12)',
              border: '1px solid rgba(201, 168, 76, 0.3)'
            }} data-id="element-77">
                🏛️
              </div>
              <div data-id="element-78">
                <h3 className="font-heading font-600 text-xl mb-2" style={{
                color: 'var(--color-gold)'
              }} data-id="element-79">
                  Rutina "Templo de Piedra"
                </h3>
                <p className="font-body text-sm leading-relaxed" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-80">
                  Ejercicios de 10 minutos para fortalecer huesos y prevenir
                  caídas. Diseñados para cuerpos de 55+.
                </p>
              </div>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.3} data-id="element-81">
            <div className="rounded-xl p-6 flex gap-5 items-start h-full md:col-span-2" style={{
            background: 'linear-gradient(135deg, rgba(201, 168, 76, 0.08), rgba(15, 31, 61, 0.9))',
            border: '1px solid rgba(201, 168, 76, 0.35)'
          }} data-id="element-82">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-xl" style={{
              background: 'rgba(201, 168, 76, 0.15)',
              border: '1px solid rgba(201, 168, 76, 0.4)'
            }} data-id="element-83">
                🛒
              </div>
              <div data-id="element-84">
                <h3 className="font-heading font-600 text-xl mb-2" style={{
                color: 'var(--color-gold-light)'
              }} data-id="element-85">
                  Lista de Compras Génesis
                </h3>
                <p className="font-body text-sm leading-relaxed" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-86">
                  Para que sepas exactamente qué buscar en el supermercado y qué
                  evitar para siempre. Sin confusión, sin excusas.
                </p>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}